import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./css/variables.css";
import "./App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";

import api from "./api";
import { initGlobalErrorHandler } from "./globalErrorHandler";
import { loadBuildMeta } from "./version/buildMeta";
import { UpdateManager } from "./services/UpdateManager";

// VKD118 🔥 Disable console logs in production (PUT HERE)
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

// Initialize global error handler for Axios, JS errors, offline/online events
initGlobalErrorHandler(api);

// Load build metadata early and start update polling (safe singleton).
loadBuildMeta().catch(() => {});
UpdateManager.start().catch(() => {});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
);

// Optional: performance reporting
reportWebVitals();
